import React from "react"
import styled from "styled-components"
import getId from "@irati/utils/id"
import GetCommentTagCountQuery from "@irati/insights/apollo/query/comment/getTagCount"
import HasPermissionTo from "@irati/utils/permissions/HasPermissionTo"
import {overrideAuth} from "@irati/insights/utils/apollo"
import {RadioFilter, CustomNodeRenderer} from "@irati/ui/src/FormItem"

import AnalysisCommentsConsumer from "../AnalysisCommentsConsumer"
import {getSentimentsListWithCount} from "../../../helpers/Sentiment"
import {SENTIMENT_TYPE} from "../../../utils/constants/comment"
import FlexWrapper from "../../../ui/Layout/FlexWrapper"
import {Image} from "../../../ui/Image"
import DropDownLabel from "../../../ui/Labels/DropdownLabel"

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 20px;
`

const SentimentHeaderRenderer = (props) => {
  const idNamespace = getId("SentimentHeaderRenderer", props)
  return (
    <HasPermissionTo permissions={["insights.bookmarkComments"]} Error={null}>
      <AnalysisCommentsConsumer>
        {({tenantId: tenant, sentiment, filters, commentsFilters, updateFilter, schedule: cycle, isDemo, demoTenantAccessToken}) => {
          const {bookmark} = commentsFilters

          const queryParams = {tenant, cycle, tagValue: SENTIMENT_TYPE, tagType: SENTIMENT_TYPE, filters: {...filters, bookmark}}

          return (
            <GetCommentTagCountQuery
              {...queryParams}
              useLoader={false}
              fetchPolicy="network-only"
              {...overrideAuth(demoTenantAccessToken, isDemo)}>
              {({tagCount}) => {
                const options = getSentimentsListWithCount(tagCount).map(({value, icon, count}) => {
                  const customNode = (
                    <FlexWrapper>
                      <Image src={icon} alt="" size={20} /> <DropDownLabel> {count} </DropDownLabel>
                    </FlexWrapper>
                  )
                  return {
                    value,
                    customNode
                  }
                })
                return (
                  <Wrapper id={idNamespace}>
                    <RadioFilter
                      rowRenderer={CustomNodeRenderer}
                      options={options}
                      value={sentiment}
                      onReset={() => updateFilter(null, SENTIMENT_TYPE)}
                      onChange={(sentimentValue) => updateFilter(sentimentValue, SENTIMENT_TYPE)} />
                  </Wrapper>
                )
              }}
            </GetCommentTagCountQuery>
          )
        }}
      </AnalysisCommentsConsumer>
    </HasPermissionTo>
  )
}

SentimentHeaderRenderer.propTypes = {}

SentimentHeaderRenderer.defaultProps = {}

export default SentimentHeaderRenderer
